import React from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');
  const isAuthRoute = ['/login', '/register'].includes(location.pathname);

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      {!isAdminRoute && <Header />}
      
      <main className={`flex-1 ${!isAdminRoute ? 'pt-16' : ''} ${isAuthRoute ? 'flex items-center justify-center' : ''}`}>
        <div className={`${!isAdminRoute && !isAuthRoute ? 'container mx-auto px-4 py-6' : ''} w-full`}>
          {children}
        </div>
      </main>
      
      {!isAdminRoute && !isAuthRoute && <Footer />}
    </div>
  );
};

export default Layout;